import React from 'react';

interface FormInputProps {
  label: string;
  required?: boolean;
  placeholder?: string;
  type?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
}

export const FormInput: React.FC<FormInputProps> = ({
  label,
  required,
  placeholder,
  type = 'text',
  value,
  onChange,
  error,
}) => {
  return (
    <div className="flex flex-col gap-1 w-full">
      <label className="font-18 font-medium text-white">
        {label} {required && <span className="text-[#FF0000]">*</span>}
      </label>

      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`bg-transparent border rounded-md px-3 py-2 text-sm text-white placeholder:text-gray-500 focus:outline-none focus:border-blue-500
        ${error ? 'border-red-500' : 'border-white/20'}`}
      />
    </div>
  );
};
